import {
    apiRequest,
    pencantumanGelarCreate,
    employeeList,
    masterEducation,
    masterEducationGroup,
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pencantumanGelarCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }

    fetchEducation= async (query) => {
        return await apiRequest("get", masterEducation, {
            params: query
        }, true)
    }

    fetchEducationGroup= async (query) => {
        return await apiRequest("get", masterEducationGroup, {
            params: query
        }, true)
    }

}

export default CreateRepository